<script setup lang="ts">
const { setHeaderVariant } = useLayout()

setHeaderVariant(HeaderVariant.TransparentWhite)
</script>

<template>
  <div class="main">
    <div class="main__container">
      <HomeSections />
    </div>
  </div>
</template>

<style lang="scss">
@use '/assets/scss/pages/main' as *;
@use '/assets/scss/components/slider' as *;
@use '/assets/scss/components/fixed-panel' as *;
</style>
